export default "__VITE_ASSET__B3X8s8oS__";